import { useLocalStorage } from "@mantine/hooks";
import { UserContext } from "./UserContext.ts";

export const userIdStorageKey = "userId";
export const rolesStorageKey = "roles";

export const UserData = (props: { children: React.ReactNode }) => {
  /**
   * `getInitialValueInEffect` steht standardmäßig auf `true` — der
   * gespeicherte Wert wird dann erst in einem Effekt nach dem Mount gelesen,
   * der erste Render liefert also `defaultValue` (hier: leerer String), auch
   * bei bestehender, gültiger Sitzung. Diese Anwendung ist reines
   * Client-Side-Rendering, es gibt keine SSR-Hydration, die der Default
   * abfedern müsste — daher hier bewusst `false`: `useHasRole` leitet aus
   * einem leeren `userId` „nicht angemeldet" ab, und `useForwardIfNotHasRole`
   * navigiert genau darauf. Bliebe der Default, würde ein eingeloggter Nutzer
   * bei jedem Reload für den ersten Render fälschlich als abgemeldet gelten.
   */
  const [userId, setUserId] = useLocalStorage({
    key: userIdStorageKey,
    defaultValue: "",
    getInitialValueInEffect: false,
  });

  const [roles, setRoles] = useLocalStorage<string[]>({
    key: rolesStorageKey,
    defaultValue: [],
    getInitialValueInEffect: false,
  });

  const setUserData = (userId: string, roles: string[]) => {
    setUserId(userId);
    setRoles(roles);
  };

  return (
    <UserContext value={{ userData: { userId, roles }, setUserData }}>
      {props.children}
    </UserContext>
  );
};
